export default "__VITE_ASSET__GytEwaDk__"